import { Component } from '@angular/core';

import { SseNotificationService } from '../sse-notification.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';

@Component({
    selector: 'pcg-install-timer',
    standalone: false,
    templateUrl: './install-timer.component.html',
    styleUrl: './install-timer.component.scss'
})
export class InstallTimerComponent {
    
    constructor(public gvs: GlobalVariablesService) {}

    toggleVisibility() { this.gvs.isScheduledInstallNotificationMinimized.set(!this.gvs.isScheduledInstallNotificationMinimized()); }
}
